import { Record as record } from 'immutable';

import trainTime from '../lib/TrainTime';
import { TimeTypes, API_ISO_FORMAT } from '../constants/AppConstants';
import { construct, resolve } from '../helpers/LinkMapper';


const defaults = {
    datetime: trainTime(),
    arriveDepart: TimeTypes.DEPART,
    windowLength: 3
};

class Timeband extends record(defaults) {

    static fromJSON (json = {}) {
        return construct(Timeband, json, {
            datetime: resolve.with(trainTime),
            arriveDepart: resolve.with(String),
            windowLength: resolve.with(Number)
        });
    }

    toRange ({ truncateStart, truncateEnd } = {}) {
        let rangeStart = this.getStart();
        let rangeEnd = this.getEnd();

        if (truncateStart && truncateStart.isAfter(rangeStart)) {
            rangeStart = truncateStart;
        }

        if (truncateEnd && truncateEnd.isBefore(rangeEnd)) {
            rangeEnd = truncateEnd;
        }

        return {
            rangeStart: rangeStart.format(API_ISO_FORMAT),
            rangeEnd: rangeEnd.format(API_ISO_FORMAT),
            arriveDepart: this.arriveDepart
        };
    }

    getWindowLength () {
        return { hours: this.windowLength };
    }

    getStart () {
        let start = this.datetime.clone();
        return (this.arriveDepart === TimeTypes.DEPART) ? start : start.subtract(this.getWindowLength());
    }

    getEnd () {
        let end = this.datetime.clone();
        return (this.arriveDepart === TimeTypes.ARRIVE) ? end : end.add(this.getWindowLength());
    }

    getEarlier (windowLength) {
        return this.subtract(windowLength ? { hours: windowLength } : this.getWindowLength());
    }

    getLater (windowLength) {
        return this.add(windowLength ? { hours: windowLength } : this.getWindowLength());
    }

    add () {
        return this.set('datetime', this.datetime.clone().add(...arguments));
    }

    subtract () {
        return this.set('datetime', this.datetime.clone().subtract(...arguments));
    }

}


export default Timeband;



// WEBPACK FOOTER //
// ./src/records/Timeband.js